import { render, staticRenderFns } from "./UrbanMixin.vue?vue&type=template&id=0cbcb5e4"
import script from "./UrbanMixin.vue?vue&type=script&lang=js"
export * from "./UrbanMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports